import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { MultiSelection } from '../../../../shared/checkbox-list/entities/multi-selection.entity';

import { SousParcTLR } from '../../sous-parc/entities/sous-parc-tlr.entity';
import { OuvrageTLR } from '../../ouvrage/entities/ouvrage-tlr.entity';

@Component({
	selector: 'filtre-geographique',
	templateUrl: 'filtre-geographique.html',
	styleUrls: ['filtre-geographique.css']
})
export class FiltreGeographiqueComponent implements AfterViewInit {
	// Indique l'etat actif/inatif de la saisie sur le composant
	@Input() disabled = false;

	// Parametrage du style
	@Input() labelClass: string | undefined;
	@Input() shortFieldClass: string | undefined;
	@Input() longFieldClass: string | undefined;

	// Observable indiquant les commandes de reinitialisation du composant
	private initialResetCommands = new Subject<void>();
	_resetCommands: Observable<void> = this.initialResetCommands;
	@Input() set resetCommands(commands: Observable<void> | undefined) {
		if (commands) {
			this._resetCommands = commands;
		} else {
			this._resetCommands = this.initialResetCommands;
		}
	}

	sousParcSelectionSubject = new Subject<number>();
	ouvragesDeselectionBySousParcSubject = new Subject<number>();

	// Elements necessaires a l'affichage des differents blocs
	showAntennes: boolean = false;
	showParcs: boolean = false;
	showOuvrages: boolean = false;
	agenceId: number | null = null;
	antenneIds: number[] = [];
	parcIds: number[] = [];

	// Sortie pour les selections de l'agence
	@Output() agenceIdChange = new EventEmitter<number | null>();

	// Sortie pour les selections d'antennes
	@Output() antenneIdsChange = new EventEmitter<MultiSelection | undefined>();

	// Sortie pour les selections de parcs
	@Output() parcIdsChange = new EventEmitter<MultiSelection | undefined>();

	// Sortie pour les selections de sous-parcs
	@Output() sousParcIdsChange = new EventEmitter<MultiSelection | undefined>();

	@Output() ouvrageIdsChange = new EventEmitter<MultiSelection | undefined>();

	constructor(
	) {
	}

	ngAfterViewInit() {
		this.initialResetCommands.next();
	}

	onSelectedAgenceIdChange(value: number | null) {
		this.agenceId = value;
		this.agenceIdChange.emit(value);

		let showAntennes = !!this.agenceId;
		if (showAntennes != this.showAntennes) {
			this.showAntennes = showAntennes;
			if (!showAntennes) {
				// Si on provoque le masquage du selecteur d'antennes, alors on passe sa valeur a 'undefined'
				this.onSelectedAntenneIdsChange(undefined);
			}
		}
	}

	onSelectedAntenneIdsChange(value: MultiSelection | undefined) {
		let showParcs = false;
		if (value) {
			this.antenneIds = value.ids;
			showParcs = this.antenneIds && this.antenneIds.length > 0
		}
		this.antenneIdsChange.emit(value);

		if (showParcs != this.showParcs) {
			this.showParcs = showParcs;
			if (!showParcs) {
				// Si on provoque le masquage du selecteur de parcs, alors on passe sa valeur a 'undefined'
				this.onSelectedParcIdsChange(undefined);
			}
		}
	}

	onSelectedParcIdsChange(value: MultiSelection | undefined) {
		let showOuvrages = false;
		if (value) {
			this.parcIds = value.ids;
			showOuvrages = this.parcIds && this.parcIds.length === 1;
		}
		this.parcIdsChange.emit(value);

		if (showOuvrages != this.showOuvrages) {
			this.showOuvrages = showOuvrages;
			if (!showOuvrages) {
				// Si on provoque le masquages des selecteurs sous-parc et ouvrage, alors on passe leur valeurs a 'undefined'
				this.onSelectedSousParcIdsChange(undefined);
				this.onSelectedOuvrageIdsChange(undefined);
			}
		}
	}

	onSousParcDeselected(sousParc: SousParcTLR) {
		const id = sousParc.id;
		this.ouvragesDeselectionBySousParcSubject.next(id);
	}

	onOuvrageSelected(ouvrage: OuvrageTLR) {
		const sousParcId = ouvrage.sousParcId;
		if (sousParcId) {
			this.sousParcSelectionSubject.next(sousParcId);
		}
	}

	onSelectedSousParcIdsChange(value: MultiSelection | undefined) {
		this.sousParcIdsChange.emit(value);
	}

	onSelectedOuvrageIdsChange(value: MultiSelection | undefined) {
		this.ouvrageIdsChange.emit(value);
	}
}